import { lazy } from "react";

// project-imports
import Loadable from "components/Loadable";

/**
 * Lazy-loaded component for rendering the list of Version Licence.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ListVersionLicencesPage - Lazy-loaded ListVersionLicencePage component.
 */
const ListVersionLicencePage = Loadable(
  lazy(() => import("./ListVersionLicencePage"))
);

/**
 * Lazy-loaded component for rendering the add Version Licence page.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} AddVersionLicencePage - Lazy-loaded AddVersionLicencePage component.
 */
const AddVersionLicencePage = Loadable(
  lazy(() => import("./AddVersionLicencePage"))
);

/**
 * Lazy-loaded component for rendering the View Version Licence page.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ViewVersionLicencePage - Lazy-loaded ViewVersionLicencePage component.
 */
const EditVersionLicencePage = Loadable(
  lazy(() => import("./EditVersionLicencePage"))
);

/**
 * Array containing route definitions for the versionLicence-related pages.
 * @constant {Object[]} versionLicenceRoutes - Array of versionLicence route objects.
 * @property {string} versionLicenceRoutes[].path - The path of the versionLicence route.
 * @property {React.ReactElement} versionLicenceRoutes[].element - The React element to be rendered for the versionLicences route.
 */
const VersionLicenceRoutes = [
  {
    path: "list",
    element: <ListVersionLicencePage />,
  },
  {
    path: "add",
    element: <AddVersionLicencePage />,
  },
  {
    path: "edit/:licence_version_id",
    element: <EditVersionLicencePage />,
  },
];

export default VersionLicenceRoutes;
